export default "__VITE_ASSET__d03be29c__"